import React from "react";
import '../../css/components/controls/HrnbInput.css'

export default function HrnbInput({
                                      label,
                                      icon,
                                      iconRight,
                                      className = "",
                                      as = "text",
                                      value,
                                      onChange,
                                      placeholder = "",
                                      error = "",
                                      onKeyDown,
                                      hint = "",
                                      disabled = false,
                                      ...props
                                  }) {
    return (
        <div className={`hrnb-input-wrap ${className} ${error ? "hrnb-input--error" : ""} ${disabled ? "hrnb-input--disabled" : ""}`}>
            {label && <label className="hrnb-input__label">{label}</label>}
            <div className="hrnb-input__control">
                {icon && <span className="hrnb-input__icon">{icon}</span>}
                <input
                    className="hrnb-input"
                    type={as}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    {...props}
                />
                {iconRight && <span className="hrnb-input__icon hrnb-input__icon--right">{iconRight}</span>}
            </div>
            {error
                ? <div className="hrnb-input__error">{error}</div>
                : hint && <div className="hrnb-input__hint">{hint}</div>
            }
        </div>
    );
}
